// export const serverBasePath = "https://api-test.regoride.com/";
// export const serverBasePath =  "https://localhost:44302/";
//export const serverBasePath = "https://195.35.28.26:8803/";
// api-key="AIzaSyAW8fSRM_RWI1vTu8MOyKmviSivTDz0Mq8"
// export const imagesPath = serverBasePath + "images/"
export const serverBasePath =  process.env.VUE_APP_SERVER_BASE_URL;
export const serverWebSitePath =  process.env.VUE_APP_SERVER_Web_Site_URL;